"use client";

import Link from "next/link";
import { CalendarClock, Moon, Sun } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

export function LandingHeader() {
  const { theme, toggle } = useTheme();

  return (
    <header className="fixed top-4 left-0 right-0 z-50 mx-auto max-w-5xl px-4 transition-all duration-300">
      <div className="flex h-14 items-center justify-between gap-4 rounded-2xl border border-border bg-background/80 px-4 sm:px-6 backdrop-blur-md shadow-sm">
        
        {/* Brand */}
        <Link
          href="/"
          className="flex items-center gap-2.5 text-sm font-semibold tracking-tight hover:opacity-90 transition-opacity"
        >
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand text-white shadow-sm">
            <CalendarClock className="h-4 w-4" aria-hidden />
          </span>
          <span className="font-bold text-base text-foreground tracking-tight">Attendance</span>
        </Link>

        {/* Actions */}
        <div className="flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={toggle}
            aria-label="Toggle color theme"
            className="flex h-8 w-8 items-center justify-center rounded-lg border border-border bg-card text-muted-foreground hover:bg-muted hover:text-foreground transition-all"
          >
            {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          </button>

          <Link href="/login" className="flex items-center justify-center rounded-lg bg-brand text-white h-8 px-4 text-xs font-semibold hover:opacity-90 transition-opacity shadow-sm">
            Sign In
          </Link>
        </div>
      </div>
    </header>
  );
}
